import React from "react";
import NavBar from "../components/NavBar";
import RentalGuidePage from "../components/RentalGuidePage";
import Footer from "../components/Footer";

const RentersGuide = () => {
    return(
        <div>
            <NavBar/>
            <RentalGuidePage/>
            <Footer/>
        </div>
    )
}

export default RentersGuide;